import React from 'react';
import {
    Datagrid,
    TextField,
    DateField,
    NumberField,
    useRecordContext,
    useListController,
    ListContextProvider,
    useListContext,
    Button,
    useRedirect,
    useTranslate,
} from 'react-admin';
import { Link } from 'react-router-dom';
import { Chip } from '@mui/material';

const BidderStatusField = (props) => {
  const record = useRecordContext(props);
  const translate = useTranslate();
  if (!record) return null;
  
  const chips = [];
  
  // Winner status chip - only show if winner
  const winnerValue = record.is_winner;
  if (winnerValue === true || winnerValue === 'true' || winnerValue === 1 || winnerValue === '1') {
    chips.push(<Chip key="winner" label="Winner" color="success" size="small" />);
  }
  
  // Bidder status chip
  const statusValue = record.status;
  if (statusValue && statusValue !== '') {
    let statusColor = 'default';
    let statusLabel = statusValue;
    
    switch (statusValue) {
      case 'LEAD':
        statusColor = 'info';
        statusLabel = 'Lead';
        break;
      case 'REJECTED':
        statusColor = 'error';
        statusLabel = 'Rejected';
        break;
      case 'PARTICIPANT':
        statusColor = 'warning';
        statusLabel = 'Participant';
        break;
      default:
        statusColor = 'default';
        statusLabel = statusValue;
    }
    
    chips.push(<Chip key="status" label={statusLabel} color={statusColor} size="small" />);
  }
  
  return (
    <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
      {chips}
    </div>
  );
};

const TenderShowButton = () => {
    const record = useRecordContext();
    if (!record || !record.tender) return null;

    return (
        <Button
            component={Link}
            to={`/tenders/${record.tender.id}/show`}
            label="View Tender"
            color="primary"
        />
    );
};

const BidderTendersDatagrid = () => {
    const { data, isLoading } = useListContext();
    const translate = useTranslate();

    if (isLoading || !data) return null;

    return (
        <Datagrid 
            bulkActionButtons={false}
            rowClick={(id, basePath, record) => record?.tender ? `/tenders/${record.tender.id}/show` : ''}
        >
            <TextField source="tender.title" label={translate('resources.tenders.fields.title')} />
            <TextField source="tender.notice_number" label={translate('resources.tenders.fields.notice_number')} />
            <BidderStatusField source="status" label={translate('resources.tenders.fields.status')} />
            <NumberField 
                source="offer_value" 
                label={translate('resources.tenders.fields.offer_value')}
                options={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
            />
            <DateField source="offer_date" label={translate('resources.tenders.fields.offer_date')} showTime />
            <TenderShowButton />
        </Datagrid>
    );
};

export const BidderTendersList = () => {
    const record = useRecordContext();
    const resource = record ? `bidders/${record.id}/offers` : null;
    const listContext = useListController({
        resource,
        sort: { field: 'offer_date', order: 'DESC' },
        perPage: 25,
        disableSyncWithLocation: true,
    });

    if (!record) return null;
    if (listContext.isLoading) return null;
    if (listContext.error) return <div>Error loading tenders</div>;

    return (
        <ListContextProvider value={listContext}>
            <div style={{ marginTop: '1em' }}>
                <BidderTendersDatagrid />
            </div>
        </ListContextProvider>
    );
}; 